const replaceIdUrl = (url, id) => {
  if (id) {
    return url.replace(':id', id);
  }
  return url;
};

export default replaceIdUrl;
